import React from 'react'
import { useRouter } from 'next/router'
import { Button } from '../../../components'
import ThankYouPage from '../../../components/organisms/ThankYouPage/ThankYouPage'
import useTrans from '../../../hooks/useTrans'

const ErrorOrdine = ({ ordine }) => {
  const t = useTrans()
  const router = useRouter()
  return (
    <ThankYouPage
      title={t('Errore')}
      text={t("E' stato riscontrato un errore durante la creazione dell'ordine")}
      buttons={[
        <Button
          label={t('Torna al carrello')}
          onClick={() => router.push('/cart')}
          variant="primary"
        />,
      ]}
    ></ThankYouPage>
  )
}

export default ErrorOrdine
